/**
 * Complete the set: toggle selection on list items and pins, update totals, add selected to cart.
 */
(function () {
  if (typeof window.routes === 'undefined' || typeof window.fetchConfig !== 'function') return;

  var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  var PUB_SUB = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : { cartUpdate: 'cart-update', cartError: 'cart-error' };

  function formatMoney(cents) {
    if (typeof window.Shopify !== 'undefined' && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    var amount = (cents / 100).toFixed(2);
    return amount.replace('.', ',') + '\u202Fz\u0142';
  }

  /**
   * Applies a discount code via Shopify's /discount/{code} endpoint.
   * Uses a fetch to the discount URL which sets the discount on the session,
   * then updates the cart sections.
   */
  function applyDiscountCode(code) {
    // Empty string clears any previously applied session discount — without this
    // a stale tier code from a prior add persists when the user switches to a
    // lower-tier selection.
    console.log('[bundle] applyDiscountCode called with code:', code);
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var updateUrl = cartUrl + '/update.js';
    console.log('[bundle] POST', updateUrl, 'body:', { discount: code || '' });
    return fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code || '' })
    })
      .then(function (res) {
        console.log('[bundle] discount response status:', res.status, res.ok);
        return res.json().catch(function () { return null; }).then(function (data) {
          console.log('[bundle] discount response body:', data);
          if (data) {
            console.log('[bundle] cart total_discount:', data.total_discount, 'total_price:', data.total_price);
            console.log('[bundle] cart_level_discount_applications:', data.cart_level_discount_applications);
            console.log('[bundle] discount_codes on cart:', data.discount_codes);
          }
          return data;
        });
      })
      .catch(function (err) {
        console.error('[bundle] discount fetch failed:', err);
        return null;
      });
  }

  function initBlock(block) {
    var items = block.querySelectorAll('.product-complete-set__item');
    var pins = block.querySelectorAll('.product-complete-set__pin');
    var savingsValueEl = block.querySelector('.product-complete-set__savings-value');
    var totalValueEl = block.querySelector('.product-complete-set__total-value');
    var btn = block.querySelector('.product-complete-set__btn');
    var tierEls = block.querySelectorAll('.product-complete-set__tier');

    // Tiered discounts configured in theme settings — keyed by number of items
    // selected (1 = no discount, 2+ = tier applies).
    var fallbackCode = block.getAttribute('data-discount-code') || '';
    var tiers = {
      2: {
        pct: parseInt(block.getAttribute('data-tier-2-pct') || '0', 10) || 0,
        code: block.getAttribute('data-tier-2-code') || ''
      },
      3: {
        pct: parseInt(block.getAttribute('data-tier-3-pct') || '0', 10) || 0,
        code: block.getAttribute('data-tier-3-code') || ''
      }
    };
    console.log('[bundle] tiers loaded from block attrs:', tiers, 'fallbackCode:', fallbackCode);

    function getActiveTier(count) {
      if (count >= 3 && (tiers[3].pct > 0 || tiers[3].code)) return tiers[3];
      if (count >= 2 && (tiers[2].pct > 0 || tiers[2].code)) return tiers[2];
      return { pct: 0, code: '' };
    }

    function getSelectedSet() {
      var set = [];
      items.forEach(function (item) {
        if (item.classList.contains('product-complete-set__item--selected')) {
          set.push({
            index: item.getAttribute('data-item-index'),
            variantId: item.getAttribute('data-variant-id'),
            price: parseInt(item.getAttribute('data-price'), 10) || 0,
            comparePrice: parseInt(item.getAttribute('data-compare-price'), 10) || 0
          });
        }
      });
      return set;
    }

    function toggleIndex(index) {
      var item = block.querySelector('.product-complete-set__item[data-item-index="' + index + '"]');
      var pin = block.querySelector('.product-complete-set__pin[data-item-index="' + index + '"]');
      if (!item) return;
      // First item is locked — must stay selected so it always anchors the bundle.
      if (item.classList.contains('product-complete-set__item--locked')) return;
      item.classList.toggle('product-complete-set__item--selected');
      if (pin) pin.classList.toggle('product-complete-set__pin--selected');
    }

    function updateTotals() {
      var set = getSelectedSet();
      var compareTotalCents = 0;
      var totalAfterCode = 0;

      // Pick discount tier based on how many items are selected.
      var tier = getActiveTier(set.length);
      var discountPct = tier.pct;
      var factor = discountPct > 0 ? (100 - discountPct) / 100 : 1;

      // Round per line (like Shopify does) and sum — otherwise the panel total
      // can differ from the cart total by 1 grosz on 50/50 rounding.
      set.forEach(function (entry) {
        compareTotalCents += entry.comparePrice > entry.price ? entry.comparePrice : entry.price;
        totalAfterCode += Math.round(entry.price * factor);
      });

      var savingsCents = Math.max(0, compareTotalCents - totalAfterCode);

      tierEls.forEach(function (el) {
        var count = parseInt(el.getAttribute('data-tier-count'), 10);
        el.classList.toggle('product-complete-set__tier--active', set.length >= count);
      });

      if (savingsValueEl) savingsValueEl.textContent = formatMoney(savingsCents);
      if (totalValueEl) totalValueEl.textContent = formatMoney(totalAfterCode);
      if (btn) {
        if (set.length > 0) {
          btn.removeAttribute('disabled');
        } else {
          btn.setAttribute('disabled', 'disabled');
        }
      }
    }

    function onItemClick(evt) {
      var item = evt.target.closest('.product-complete-set__item');
      if (!item || !block.contains(item)) return;
      var index = item.getAttribute('data-item-index');
      if (!index) return;
      evt.preventDefault();
      toggleIndex(index);
      updateTotals();
    }

    function onItemKeydown(evt) {
      if (evt.key !== 'Enter' && evt.key !== ' ') return;
      var item = evt.target.closest('.product-complete-set__item');
      if (!item || !block.contains(item)) return;
      evt.preventDefault();
      if (evt.key === ' ') evt.stopPropagation();
      var index = item.getAttribute('data-item-index');
      if (!index) return;
      toggleIndex(index);
      updateTotals();
    }

    function onPinClick(evt) {
      var pin = evt.target.closest('.product-complete-set__pin');
      if (!pin || !block.contains(pin)) return;
      var btnPin = evt.target.closest('.product-complete-set__pin-btn');
      if (!btnPin) return;
      evt.preventDefault();
      evt.stopPropagation();
      var index = pin.getAttribute('data-item-index');
      if (!index) return;
      toggleIndex(index);
      updateTotals();
    }

    items.forEach(function (item) {
      item.addEventListener('click', onItemClick);
      item.addEventListener('keydown', onItemKeydown);
    });

    pins.forEach(function (pin) {
      var pinBtn = pin.querySelector('.product-complete-set__pin-btn');
      if (pinBtn) pinBtn.addEventListener('click', onPinClick);
    });

    if (btn) {
      btn.addEventListener('click', function addSetToCart(evt) {
        evt.preventDefault();
        if (btn.hasAttribute('disabled') || btn.classList.contains('loading')) return;
        var set = getSelectedSet();
        // Pick tier code based on how many items are selected. With 1 item there
        // is no bundle — user gets the product at regular price.
        var activeTier = getActiveTier(set.length);
        var discountCode = activeTier.code;
        console.log('[bundle] DODAJ ZESTAW clicked. selected:', set.length, 'tier pct:', activeTier.pct, 'code:', discountCode);
        if (set.length === 0) return;

        btn.classList.add('loading');
        btn.setAttribute('aria-disabled', 'true');

        var config = window.fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (cart && typeof cart.getSectionsToRender === 'function') {
          config.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          config.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
        }

        var lastResponse = null;
        var chain = Promise.resolve();

        // Add items first, then apply discount — the code only evaluates
        // against items currently in the cart, so it must be applied after.
        set.forEach(function (entry) {
          var variantId = entry.variantId;
          chain = chain.then(function () {
            var formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', '1');
            if (config.sections) {
              formData.append('sections', config.sections);
              formData.append('sections_url', config.sections_url);
            }
            var reqConfig = { method: 'POST', headers: config.headers, body: formData };
            return fetch(window.routes.cart_add_url, reqConfig).then(function (res) { return res.json(); });
          }).then(function (response) {
            lastResponse = response;
            if (response.status) {
              if (typeof publish === 'function') {
                publish(PUB_SUB.cartError, {
                  source: 'product-complete-set',
                  productVariantId: variantId,
                  errors: response.errors || response.description,
                  message: response.message
                });
              }
              if (response.message) alert(response.message);
              return Promise.reject(new Error('add failed'));
            }
            return Promise.resolve();
          });
        });

        chain
          .then(function () {
            if (!cart) {
              // If discount code present and no cart drawer, redirect through discount URL
              if (discountCode) {
                var discountRedirect = '/discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(window.routes.cart_url || '/cart');
                window.location.href = discountRedirect;
              } else {
                window.location.href = window.routes.cart_url;
              }
              return;
            }
            var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
            // Apply discount AFTER items are in cart so Shopify evaluates the code's
            // conditions against the actual cart. Then fetch the freshly-rendered
            // cart-drawer section so the drawer shows the discounted totals.
            // Always call applyDiscountCode — pass empty string to clear any
            // stale session discount when no tier applies.
            var applyPromise = applyDiscountCode(discountCode);
            return applyPromise.then(function () {
              return fetch(cartUrl + '?section_id=cart-drawer', {
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
            })
              .then(function (res) { return res.text(); })
              .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var freshDrawer = doc.querySelector('#CartDrawer');
                var currentDrawer = document.querySelector('#CartDrawer');
                if (freshDrawer && currentDrawer) {
                  currentDrawer.innerHTML = freshDrawer.innerHTML;
                }
                var drawerInner = document.querySelector('cart-drawer .drawer__inner');
                if (drawerInner) drawerInner.classList.remove('is-empty');
                var cartDrawerEl = document.querySelector('cart-drawer');
                if (cartDrawerEl) {
                  cartDrawerEl.classList.remove('is-empty');
                  if (typeof cartDrawerEl.open === 'function') cartDrawerEl.open();
                }
                // Also refresh the header cart icon bubble.
                return fetch(cartUrl + '?section_id=cart-icon-bubble').then(function (r) { return r.text(); }).then(function (bubbleHtml) {
                  var bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
                  var bubbleSrc = bubbleDoc.querySelector('.shopify-section');
                  var bubbleTarget = document.getElementById('cart-icon-bubble');
                  if (bubbleSrc && bubbleTarget) bubbleTarget.innerHTML = bubbleSrc.innerHTML;
                });
              })
              .then(function () {
                if (typeof publish === 'function') {
                  publish(PUB_SUB.cartUpdate, { source: 'product-complete-set' });
                }
              });
            });
          })
          .catch(function () {})
          .finally(function () {
            btn.classList.remove('loading');
            btn.removeAttribute('aria-disabled');
          });
      });
    }

    updateTotals();
  }

  function init() {
    document.querySelectorAll('.product-complete-set').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.detail && e.detail.sectionId;
    if (!section) return;
    var container = document.querySelector('#ProductMediaBelow-' + section);
    if (container) container.querySelectorAll('.product-complete-set').forEach(initBlock);
  });
})();